export const { VITE_SST_API_URL: SST_API_URL } = import.meta.env
export const { VITE_ENV: ENV } = import.meta.env
